const imp = () => import(/* webpackChunkName: "loadSprite_logo"*/  "../sprite/loadSprite_logo");
const loadMap_logo: { [key: string]: () => Promise<any> } = {
  "Icon-kingdee": imp,
  "Icon-qixinbao": imp,
  "Icon-yonyou": imp,
  "Icon-jingdouyun": imp,
  "Icon-nccloud": imp,
  "Icon-U8+": imp,
  "Icon-yunxingkong": imp,
}
export default loadMap_logo;